import { ApolloLink, split } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'
import { envs } from '@config/envs'

import {
  authMiddleware,
  graphQLErrorsMiddleware,
  httpMiddleware,
  loggerMiddleware,
  networkErrorsMiddleware,
  refreshTokenMiddleware,
  wsMiddleware,
} from './middlewares'

const linksHttp = () =>
  ApolloLink.from([
    authMiddleware,
    refreshTokenMiddleware,
    networkErrorsMiddleware,
    graphQLErrorsMiddleware,
    ...(envs.isDevelopment ? [loggerMiddleware] : []),
    httpMiddleware,
  ])

export const splitLink =
  typeof global.window !== 'undefined'
    ? split(
        ({ query }) => {
          const definition = getMainDefinition(query)
          return (
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
          )
        },
        wsMiddleware(),
        linksHttp()
      )
    : linksHttp()
